import React, { useContext } from "react";
import { cn } from "~/utils";
import { Select, SelectItem } from "~/components/parts/Select";
import TextArea from "~/components/parts/TextArea";
import { SubscriptionContext } from "../../..";
import { ApplicationFormContext } from ".";

const Other = () => {
  const { form = {} } = useContext(SubscriptionContext);
  const { values = {}, validity = {} } = form;

  const { handleInputChange } = useContext(ApplicationFormContext);

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <p className="col-span-1 m-0 -mb-3 text-sm font-semibold text-slate-700 lg:col-span-2 xl:col-span-3">
        Other details
      </p>
      <Select
        className={cn(
          "max-h-[36px]",
          values.rateRequested ? "" : "text-gray-400",
        )}
        label="Discount requested"
        invalid={validity["rateRequested"] === false}
        name="rateRequested"
        onChange={handleInputChange}
        value={values.rateRequested}
      >
        <SelectItem value="" label="Please select" disabled />
        <SelectItem value="0.75" label="25% off" />
        <SelectItem value="0.5" label="50% off" />
        {values.schoolType === "Specialist" && (
          <SelectItem value="0.25" label="75% off" />
        )}
      </Select>
      <TextArea
        className="h-32 placeholder:text-gray-400"
        containerClassName="xl:col-span-2"
        label="Other relevant information"
        invalid={validity["otherInformation"] === false}
        name="otherInformation"
        onChange={handleInputChange}
        placeholder="e.g. extenuating financial circumstances for this year, number of students with EHCPs, number of non-specialist teachers and ECTs, recent changes in Ofsted rating, etc."
        value={values.otherInformation}
      />
    </div>
  );
};

export default Other;
